'use client';
import {createTheme} from "@mui/material/styles";

export const baseStyles = {
    fontFamily: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif"
}
export const darkTheme = createTheme({
    typography: {
        fontFamily: `${baseStyles.fontFamily}!important`
    },
    palette: {
        mode: 'dark',
        texts: {
            main: "#f9f9f9",
            sidebar: "#909DAC",
            sidebarFocused: "#FFAB00",
            sidebar_main: "#61D0FF",
            menuBarIcon: "white",
            sidebarDivider: "#333333",
            heading: "#FFAB00",
            link: "#61D0FF",
            trending: {
                up: "#22C55E",
                down: "#FFAB00"
            },
            applicationStatus: {
                draft: "#808080",
                submitted: "#3E98C7",
                paymentPending: "#FFAB00",
                paymentReceived: "#66CDAA",
                completed: "#367c2b",
                cancelled: "#d11d22"
            }
        },
        backgrounds: {
            main: "#141A21",
            primary: "#1C252E",
            secondary: "#000000",
            sidebar: "#24292E",
            topBar: "#171717",
            dashboardCards: "#1C252E",
            breadcrumb: "#000",
            form: "#24292E",
            lightError: "#d11d22",
        },
        icons: {
            sidebar: "#61D0FF"
        },
        hovers: {
            sidebar_icons: "#323232"
        },
        borders: {
            barChartBorderColor: "#323232",
            formDivider: "#393939",
            mainDivider: "#393939",
            contactInput: "rgba(255, 255, 255, 0.23)"
        },
        analyticsIcon: {
            background: "rgb(97, 208, 255)",
            text: "#323232"
        }
    },
});

export const lightTheme = createTheme({
    typography: {
        fontFamily: `${baseStyles.fontFamily}!important`
    },
    palette: {
        mode: 'light',
        texts: {
            primary: "#fff",
            main: "#323232",
            sidebar: "#323232",
            sidebarFocused: "#a87206",
            sidebar_main: "#3899E5",
            menuBarIcon: "black",
            cardTopLabel: "grey",
            sidebarDivider: "#f1f1f1",
            light: "#f9f9f9",
            heading: "#d11d22",
            link: "#0d7fd7",
            trending: {
                up: "#22C55E",
                down: "#FFAB00"
            },
            applicationStatus: {
                draft: "#808080",
                submitted: "#3E98C7",
                paymentPending: "#FFAB00",
                paymentReceived: "#66CDAA",
                completed: "#367c2b",
                cancelled: "#d11d22"
            }
        },
        backgrounds: {
            primary: "#fff",
            secondary: "#f4f4f4",
            main: "#fff",
            sidebar: "#f9f9f9",
            analyticsCard: "#fff",
            dashboardTable: "#F4F6F8",
            topBar: "#f9f9f9",
            error: "#d11d22",
            lightError: "#FFC1C3",
            breadcrumb: "#ebf6f3",
            dashboardCards: "#f7f8f8",
            form: "#f4f4f4",
            bar_1: "#66CDAA",
            bar_2: "#3E98C7",
            bar_3: "#FFAB00"
        },
        icons: {
            sidebar: "#3899E5"
        },
        hovers: {
            sidebar_icons: "#f4f4f4"
        },
        borders: {
            main: "#f4f4f4",
            barChartBorderColor: "#f4f4f4",
            formDivider: "#c9c9c9",
            mainDivider: "#f3e8e8",
            contactInput: "rgba(0, 0, 0, 0.23)"
        },
        analyticsIcon: {
            background: "#556ee640",
            text: "rgb(85,110,230)"
        }
    },
});
